// 域名重定向中间件 - 在服务端执行，页面渲染之前重定向
import { useMainStore } from "~/composables/store";

export default defineNuxtRouteMiddleware(async (to, from) => {
  // 获取 store 中的 siteInfo
  const store = useMainStore();
  const siteInfo = store.getSiteInfo();
  
  if (!siteInfo) {
    return;
  }
  
  const configData = siteInfo?.configData;
  
  if (!configData) {
    return;
  }

  let domainTree = [];
  
  // 解析 configData（可能是字符串格式）
  if (typeof configData === 'string') {
    try {
      const parsedConfigData = JSON.parse(configData);
      domainTree = parsedConfigData?.domainTree || [];
    } catch (e) {
      console.error('Failed to parse configData:', e);
      return;
    }
  } else {
    domainTree = configData?.domainTree || [];
  }

  if (!domainTree || domainTree.length === 0) {
    return;
  }

  // 获取当前请求的 host
  let currentHost = '';
  
  if (process.server) {
    // 服务端：从请求头获取 host
    const headers = useRequestHeaders();
    currentHost = headers.host || '';
  } else if (process.client) {
    // 客户端：从 window.location 获取
    currentHost = window.location.host;
  }
  
  if (!currentHost) {
    return;
  }

  // 遍历 domainTree，查找当前域名是否在子域名列表中
  for (const mainDomainNode of domainTree) {
    const mainDomain = mainDomainNode.domain;
    const children = mainDomainNode.children || [];

    // 提取主域名的 host
    let mainDomainHost = '';
    try {
      const mainUrl = new URL(mainDomain);
      mainDomainHost = mainUrl.host;
    } catch (e) {
      mainDomainHost = mainDomain.replace(/^https?:\/\//, '').replace(/\/$/, '');
    }

    // 如果当前域名就是主域名，不需要重定向
    if (currentHost === mainDomainHost) {
      continue;
    }

    for (const subDomain of children) {
      const subDomainUrl = subDomain.domain;
      const subDomainType = subDomain.type;

      // 提取子域名的 host 进行比较
      let subDomainHost = '';
      try {
        const url = new URL(subDomainUrl);
        subDomainHost = url.host;
      } catch (e) {
        subDomainHost = subDomainUrl.replace(/^https?:\/\//, '').replace(/\/$/, '');
      }

      // 检查当前域名是否匹配子域名
      if (currentHost === subDomainHost) {
        // 只有类型是 redirect 时才重定向到主域名
        if (subDomainType === 'redirect') {
          const currentPath = to.fullPath || '/';
          const normalizedMainDomain = mainDomain.endsWith('/') ? mainDomain : `${mainDomain}/`;
          const targetUrlObj = new URL(currentPath, normalizedMainDomain);
          targetUrlObj.searchParams.set('redirectSubDomain', subDomainHost);
          const targetUrl = targetUrlObj.toString();

          // 使用 navigateTo 进行外部重定向
          return navigateTo(targetUrl, { external: true, redirectCode: 301 });
        }
      }
    }
  }
});
